export default __webpack_public_path__ + "static/media/yearn.e2518f15.png";